// Source: https://github.com/mui/material-ui/blob/v6.4.0/docs/data/material/components/tooltips/CustomizedTooltips.tsx
import * as React from "react"
import { styled } from "@mui/material/styles"
import {Box} from "@mui/material"
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip"
import Typography from "@mui/material/Typography"
import InfoIcon from '@mui/icons-material/Info'

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:"rgba(0, 0, 0, 0.87)",
    color: "rgba(255, 255, 255, 0.77)",
    fontFamily: "Inter",
    fontWeight: 200,
    fontSize: 14,
    maxWidth: 500
  }
}))

export default function About() {
  return (
    <HtmlTooltip
      title={
        <React.Fragment>
          <Typography fontFamily={"inherit"} fontSize={"inherit"} fontWeight={"inherit"} color={"inherit"}>
            Nine hundred and ninety nine [999] artifacts. Hand-crafted by the community, with a bit of algorithmic assistance. 
            In creating generative algorithms, we trade control for spontaneity. We give up <i>some</i> control over the output to 
            give way to random chance. Typically one parameterizes the random choices an algorithm can make and constrains them
            to some reasonable range of values. An interesting twist on this process is to let others set these parameters 
            (rather than the machine).
          </Typography>
          <Box margin={2}></Box>
          <Typography fontFamily={"inherit"} fontSize={"inherit"} fontWeight={"inherit"} color={"inherit"}>
            This gives way to an interesting experiment whereby the artist creates the guardrails (parameters) for others to inject 
            their own creativity or taste within a larger collection. Should the collection be parameterized to enable maximum 
            creativity or constrain the outputs into a more cohesive set? Are others motivated to learn the parameter space or 
            willing to spend time searching for interesting seeds? Is there an appetite for this kind of engagement with the algorithm 
            or is it preferable to leave it all to fate? These were some of the many questions asked (and some answered) during this project.
          </Typography>
          <Box margin={2}></Box>
          <Typography fontFamily={"inherit"} fontSize={"inherit"} fontWeight={"inherit"} color={"inherit"}>
            This was conceptualized from playing around with ASCII blocks that sort of looked like various parts of a spaceship and a short
            lived phase of storing ASCII art on Polygon [L2]. The idea was to create a rich algorithm capable of generating a wide 
            range of ship-esque outputs from small subunits. Those who interacted fed a block hash and select parameters to a generative
            algorithm using forced-symmetry to randomly generate body, wings, thrusters and shooters. From this initial seed, the
            ship width/height/components, blasters (or thrusters), and colors could be controlled within a tight
            parameter space.
          </Typography>
        </React.Fragment>
      }
      >
      <InfoIcon color="primary" fontSize={"small"}/>
    </HtmlTooltip>
  )
}
